<div class="popup-content-wrapper">
  <p class="popup-title">Faltan entradas de algún abono</p>
  <p class="popup-body">Debes añadir al carrito entradas de todos los eventos de los abonos</p>
  <p class="popup-body">Los abonos de los que faltan entradas son:</p>
  <ul class="popup-list">
    <li *ngFor="let bond of data.bonds">{{ bond }}</li>
  </ul>
</div>